import { render, staticRenderFns } from "./MobileRecordingIndication.vue?vue&type=template&id=4b409810&scoped=true&"
var script = {}
import style0 from "./MobileRecordingIndication.vue?vue&type=style&index=0&id=4b409810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b409810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b409810')) {
      api.createRecord('4b409810', component.options)
    } else {
      api.reload('4b409810', component.options)
    }
    module.hot.accept("./MobileRecordingIndication.vue?vue&type=template&id=4b409810&scoped=true&", function () {
      api.rerender('4b409810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/MobileRecordingIndication.vue"
export default component.exports